import { Entry } from '../Entry'

export function Entry20231011() {
  return (
    <Entry title="Oct 11 2023 - v3.5.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/14482/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
